import React from 'react';
import './Pill.css';

export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: 'amber' | 'green' | 'red' | 'neutral';
  tabular?: boolean;
}

export const Pill = React.forwardRef<HTMLSpanElement, PillProps>(
  ({ tone = 'neutral', tabular = false, className = '', ...rest }, ref) => (
    <span
      ref={ref}
      className={`a-pill a-pill--${tone} ${tabular ? 'a-pill--tabular' : ''} ${className}`.trim().replace(/\s+/g, ' ')}
      {...rest}
    />
  )
);
Pill.displayName = 'Pill';
